var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ToolBar'),_c('v-container',[_c('v-row',{staticClass:"pb-5 pt-4",attrs:{"justify":"center"}},[_c('h1',[_vm._v("Nasci no Hospital Dois Pinheiros")])]),_c('Institutional',{attrs:{"categories":_vm.categories}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }